<template>
  <div>
    <b-card bg-variant="light">
      <interest-dropdown @selectedItems="setInterestId" :filtering="interest_filtering" heading="Product Listing Interest"></interest-dropdown>
      <product-listing-index v-if="interest_id" :filtering="product_listing_filtering"></product-listing-index>
    </b-card>
  </div>
</template>

<script>
import InterestDropdown from './InterestDropdown.vue'
import ProductListingIndex from './ProductListingIndex.vue'

export default {
  components: {
    ProductListingIndex,
    InterestDropdown
  },
  data() {
    return {
      interest_id: undefined,
      interest_filtering: {
        ids: this.$store.getters['cached_products/interest_ids']
      },
      product_listing_filtering: {
        interest_subtree_ids: undefined
      }
    }
  },
  methods: {
    setInterestId(items) {
      this.interest_id = items[0].id
      this.product_listing_filtering.interest_subtree_ids = this.interest_id
    }
  }
}
</script>

<style>

</style>